@if (isLoadingData) {
    <div class="flex justify-center">
        <p-progress-spinner ariaLabel="loading" />
    </div>
}
@else {
    <div class="grid grid-cols-2 gap-2">
        <div class="col-span-1">
            <app-product-detail-infos-input [(product)]="product" type="select" label="Marque" property="marque" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
        <div class="col-span-1">
            <app-product-detail-infos-input [(product)]="product" type="select" label="Gamme" property="gamme" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
        <div class="col-span-1">
            <app-product-detail-infos-input [(product)]="product" type="text" label="Référence" property="reference" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
        <div class="col-span-1">
            <app-product-detail-infos-input [(product)]="product" type="number" suffix=" €" label="Coûts comptables" property="couts_comptables" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
        <div class="col-span-1">
            <app-product-detail-infos-input [(product)]="product" type="select" label="Catégorie" property="categorie" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
        <div class="col-span-1">
            <app-product-detail-infos-input [(product)]="product" [disabled]="isSubCategoryDisabled" [filter]="subCategoryFilter" type="select" label="Sous-catégorie" property="sous_categorie" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
        <div class="col-span-2">
            <app-product-detail-infos-input [(product)]="product" type="link" label="Document" property="document_url" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-input>
        </div>
        <div class="col-span-2">
            <app-product-detail-infos-textarea [(product)]="product" label="Description" property="description" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-textarea>
        </div>
        <div class="col-span-2">
            <app-product-detail-infos-textarea [(product)]="product" label="Commentaire" property="commentaire" (isSendingData)="sendingDataHandler($event)"></app-product-detail-infos-textarea>
        </div>
    </div>
}